import { CircularProgress, Grid } from "@material-ui/core";
import { Send } from "@material-ui/icons";
import * as React from "react";
import { Button, Toolbar, useNotify, useRefresh } from "react-admin";
import EightWingsStorageSelectInputs from "../../../../Components/EightWingsComponents/EightWingsStorageSelectInputs";
import { Form } from "react-final-form";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import { OwnerType, OwnerTypeDesc } from "../../../../Enums/OwnerTypes";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { useAppDataProvider } from "../../../../dataprovider";
import { useHistory } from "react-router-dom";

export const AarStorageSelectForm = props => {
  const [loading, setLoading] = React.useState(false);
  var dataProvider = useAppDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const history = useHistory();
  const handleSubmit = model => {
    dataProvider
      .post("eightwings/sendtoopen", {
        RequestId: props?.selectedData?.id,
        pn: model.pn,
        sn: model.sn,
        storage: model.storage,
      })
      .then(result => {
        props?.finalCallBack?.();
        notify(`Sent to 8W`, "success", false, true);
        history.push("/eightwings/" + result.data);
        refresh();
      })
      .catch(result => notify(`${result}`, "error", false, true));
  };
  const isFormVisible = () => {
    var ownerCode = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description ?? "";
    if (
      [PbhRequestStatus.Open, PbhRequestStatus.UnshippedSvc].some(x => x == props?.selectedData?.requestStatus) &&
      props?.selectedData.ownerCode == ownerCode
    ) {
      return true;
    }
    return false;
  };
  return isFormVisible() ? (
    <Form
      onSubmit={handleSubmit}
      render={({ handleSubmit, form }) => (
        <form onSubmit={handleSubmit}>
          <Grid {...props.gridContainerProps}>
            <SectionTitle label="Send To Eight Wings" />
          </Grid>
          <Grid {...props.gridContainerProps} alignItems={"flex-start"}>
            <Grid item xs={12} sm={8}>
              <EightWingsStorageSelectInputs
                isUpdate={false}
                form={form}
                requirementCategoryList={props?.selectedData?.requirementCategoryList}
                selectedRequirementCategory={props?.selectedData?.requirementCategory}
              />
            </Grid>
          </Grid>

          <Toolbar {...props} placeholder="" classes={props.classes}>
            <Button
              label={loading ? "Sending!" : "SEND TO 8W"}
              disabled={loading}
              size="medium"
              variant="contained"
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress size="2rem" color="secondary" /> : <Send />}
            </Button>
          </Toolbar>
        </form>
      )}
    />
  ) : (
    <></>
  );
};

export default AarStorageSelectForm;
